import script from "./AdminList.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminList.vue?vue&type=script&setup=true&lang=js"

import "./AdminList.vue?vue&type=style&index=0&id=489a495b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489a495b"]])

export default __exports__